import React from 'react'

export default function VisiGiftScratchHistory() {
  return (
    <div>VisiGiftScratchHistory</div>
  )
}
